import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { getUser } from '~/selectors/user.selectors';

import { type SetUserVariables } from './useFullStoryUserVars';

/**
 * Forwards user's billing and fraud status to FullStory.
 */
export const useFullStoryBillingStatus = ({
  setUserVariables,
}: {
  setUserVariables: SetUserVariables;
}) => {
  const user = useSelector(getUser);

  useEffect(() => {
    if (!user) return;

    setUserVariables({
      blocked_billing: user.blockedBilling,
      fraud_status: user.fraudStatus,
      has_failed_payment: user.hasFailedPayment,
      is_idv_required: user.isIDVRequired,
      is_prepaid_billing: user.isPrepaidBilling,
    });
  }, [user, setUserVariables]);
};
